import React from 'react';
import { useBrokerDetailsStore } from '../../../../state/brokerDetailsStore';
import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';

export const W9OnFileField: React.FC = () => {
    const hasSubmittedW9 = useBrokerDetailsStore((s) => s.hasSubmittedW9);
    const updateFields = useBrokerDetailsStore((s) => s.updateFields);
    const w9Url = useBrokerDetailsStore((s) => s.w9Url);

    return (
        <>
            <YesNoToggleButton
                id='hasSubmittedW9'
                value={hasSubmittedW9}
                onItemClick={(e: ButtonGroupTypes.ItemClickEvent) =>
                    updateFields({ hasSubmittedW9: e.itemData?.id === 'Yes' })
                }
                label='W-9 on file?'
                labelSize={ToggleButtonLabelSize.Small}
            />

            {w9Url && (
                <>
                    {' '}
                    (<a href={w9Url}>Download W9</a>)
                </>
            )}
        </>
    );
};
